/**
 * OpenTasksBanner: "N open tasks" under the venue page header, for everyone who
 * can open the venue, linking to the tasks on the Marketing tab.
 *
 * A labelled region of plain content, not a live region: it is present from the
 * first paint, so a status role would announce nothing useful. Read-only, and
 * absent when there is nothing to say (zero tasks, or a count that has not
 * arrived). Its warning stripe and icon match the chip and the nav dot.
 */
import { ListChecks } from 'lucide-react';
import { Link } from 'react-router-dom';

import { openTasksLabel } from '../open-tasks';

import { ACTION_ITEMS_ANCHOR } from './marketing-note-lists';
import { useOpenTaskCount } from './use-open-task-count';
import { VENUES_ROUTE } from './venue-detail-path';

export function OpenTasksBanner({ venueId }: { venueId: string }) {
  const count = useOpenTaskCount(venueId);
  if (!count) return null;

  return (
    <section
      className="nb-card"
      aria-label="Open tasks"
      style={{ flex: '0 0 auto', borderLeft: '3px solid var(--nb-warn)', padding: '12px 16px' }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <ListChecks size={16} color="var(--nb-warn)" aria-hidden="true" />
        <span style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--nb-ink)' }}>
          {openTasksLabel(count)}
        </span>
        <Link
          to={`${VENUES_ROUTE}/${encodeURIComponent(venueId)}/marketing#${ACTION_ITEMS_ANCHOR}`}
          style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--nb-primary)' }}
        >
          View tasks
        </Link>
      </div>
    </section>
  );
}
